<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="configDialogVisible" :before-close="handleCloseDialog">
            <el-form :model="configAdd" :rules="dataRules" ref="configAdd" v-loading="formLoading" class="ml20 mr20" label-position="left" label-width="120px">
                <el-form-item label="标题" prop="title">
                    <div v-if="this.configData.type === 'isDetail'">{{configAdd.title}}</div>
                    <el-input v-else v-model="configAdd.title" placeholder="请输入标题, 如: XXX监管系统"></el-input>
                </el-form-item>
                <el-form-item label="应用key" prop="appKey">
                    <div v-if="this.configData.type === 'isDetail'">{{configAdd.appKey}}</div>
                    <div v-else>
                        <el-input class="w300" v-model="configAdd.appKey" placeholder="请输入应用key"></el-input>
                        <el-button @click="getKey" class="fr" style="margin-top: 3px;" type="warning">随机生成</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="区域编码" prop="areaCode">
                    <div v-if="this.configData.type === 'isDetail'">{{configAdd.areaCode}}</div>
                    <el-input v-else v-model="configAdd.areaCode" placeholder="请输入区域编码, 多个编码用逗号“,”隔开，如: 5101,5102"></el-input>
                </el-form-item>
                <el-form-item label="URL" prop="appUrl">
                    <div v-if="this.configData.type === 'isDetail'">{{configAdd.appUrl}}</div>
                    <el-input v-else v-model="configAdd.appUrl" type="textarea" :rows="4" placeholder="请输入url, 如: http://smart-xxx.ybveg.com"></el-input>
                </el-form-item>
                <el-form-item label="是否启用" prop="available">
                    <div v-if="this.configData.type === 'isDetail'">{{configAdd.available == 1 ? '启用' : '禁用'}}</div>
                    <el-switch v-else v-model="configAdd.available" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否" style="margin-left:-26px"></el-switch>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <div v-if="this.configData.type === 'isDetail'">{{configAdd.remark}}</div>
                    <el-input v-else type="textarea" :rows="4"	v-model="configAdd.remark" placeholder="请输入发布地址, 300字以内"></el-input>
                </el-form-item>
            </el-form>
            <div v-if="this.configData.type !== 'isDetail'" class="footer">
                <el-button @click="cancle" round>关闭</el-button>
                <el-button type="primary" @click="submit('configAdd')" round>保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as configApi from '@/api/sysConfig'
import {getUUID} from '@/utils/uuid'
export default {
    name: 'ConfigDialog',
    data() {
        return {
            dialogTitle: '添加配置',
            dialogVisible: false,
            formLoading: false,
            configAdd: {
                appId: '',
                appKey: '',
                appUrl: '',
                areaCode: '',
                available: 0,
                remark: '',
                title: ''
            },
            dataRules: {
                title: [
                    { required: true, message: '请输入标题, 如: XXX监管系统', trigger: 'blur' }
                ],
                appKey: [
                    { required: true, message: '请输入应用key', trigger: 'blur' }
                ],
                areaCode: [
                    { required: true, message: '请输入区域编码, 多个编码用逗号“,”隔开，如: 5101,5102', trigger: 'blur' }
                ],
                appUrl: [
                    { required: true, message: '请输入url, 如: http://smart-xxx.ybveg.com', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        queryParams: function() {
            return {
                appId: this.configAdd.appId,
                appKey: this.configAdd.appKey,
                appUrl: this.configAdd.appUrl,
                areaCode: this.configAdd.areaCode,
                available: this.configAdd.available,
                remark: this.configAdd.remark,
                title: this.configAdd.title,
            }
        }
    },
    props: {
        configDialogVisible: {
            required: true,
            type: Boolean
        },
        configData: {
            type: Object,
            required: true
        }
    },
    methods: {
        // 随机生成应用key
        getKey() {
            this.$set(this.configAdd,'appKey',getUUID())
        },
        getDetail() {
            this.formLoading = true;
            this.configAdd.appId = this.configData.appId;
            configApi.getConfigDetail({appId: this.configAdd.appId}).then(r=>{
                if(r.code === 200) {
                    this.configAdd = r.data
                    this.formLoading = false
                }
            })
        },
        submit(configAdd) {
            this.$refs[configAdd].validate((valid) => {
                if (valid) {
                    if(this.configData.type === 'isAdd') {
                        configApi.addConfig(this.queryParams).then(r=>{
                            if(r.code === 200) {
                                this.$message.success('添加成功!')
                                this.$parent.getConfigList();
                                this.handleCloseDialog();
                            }
                        }).catch(e=>{})
                    } else if(this.configData.type === 'isEdit') {
                        configApi.updateConfig(this.queryParams).then(r=>{
                            if(r.code === 200) {
                                this.$message.success('编辑成功!')
                                this.$parent.getConfigList();
                                this.handleCloseDialog();
                            }
                        }).catch(e=>{})
                    }
                };
            });
        },
        cancle() {
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$emit('closeConfigDialog');
        }
    },
    mounted() {
        if(this.configData.type === 'isAdd') { // 添加
            this.configAdd = {}
        } else if(this.configData.type === 'isEdit') { // 编辑
            this.dialogTitle = '编辑配置';
            this.getDetail();
        } else if(this.configData.type === 'isDetail') { // 详情
            this.dialogTitle = '配置详情';
            this.getDetail();
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>